import { Button, Checkbox, Col, Form, Input, Row, Space } from 'antd';
import React from 'react';
import { checkEmailIsDuplicated } from '../../api/constlink';
import { User } from '../../modules/auth';
import Link from 'antd/lib/typography/Link';
import PasswordValidator from 'password-validator';
import { checkGeneralPhoneNumber } from '../../util/utils';

interface ProfileCreateUpdateComponentProps {
  data?: User;
  onFinish: (data: User) => void;
  onCancel: () => void;
}
function ProfileCreateUpdateComponent({
  data,
  onFinish,
  onCancel,
}: ProfileCreateUpdateComponentProps) {
  const [form] = Form.useForm();

  let title: string;
  if (!!data) {
    title = '내 계정 정보 수정';
  } else {
    title = '회원가입(사용자 등록)';
  }

  const _checkEmailIsDuplicated = async (email: string) => {
    const res = await checkEmailIsDuplicated({
      data: {
        email,
      },
    });
    if (res.isDuplicate) return Promise.reject('중복된 이메일이 존재 합니다.');
    else return Promise.resolve();
  };

  const validatePassword = (value: string) => {
    const schema = new PasswordValidator();
    schema
      .is()
      .min(8)
      .is()
      .max(20)
      .has()
      .uppercase()
      .has()
      .lowercase()
      .has()
      .digits(1)
      .has()
      .not()
      .spaces();

    if (!value) {
      return Promise.reject(new Error('비밀번호는 필수 항목입니다.'));
    }

    if (!schema.validate(value)) {
      return Promise.reject(
        new Error(
          // '영문 대 소문자, 숫자, 특수문자를 조합한 8자 이상이어야 합니다.',
          '영문 대 소문자, 숫자를 조합한 8자 이상이어야 합니다.',
        ),
      );
    }
    return Promise.resolve();
  };

  const validatePassword2 = (value: string) => {
    if (
      form.getFieldValue('password') &&
      form.getFieldValue('password') !== value
    ) {
      return Promise.reject(new Error('비밀번호가 일치하지 않습니다.'));
    }
    return Promise.resolve();
  };

  return (
    <>
      <Row>
        <Col flex={1}>
          <h1>{title}</h1>
        </Col>
      </Row>
      <Form
        form={form}
        layout="vertical"
        name="control-hooks"
        onFinish={onFinish}
        initialValues={data}
      >
        <Row justify="center">
          <Col span={11}>
            <Form.Item
              name="name"
              label="이름"
              rules={[
                {
                  required: true,
                  message: '이름을 입력 하세요.',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          {!data && (
            <Col span={11}>
              <Form.Item
                name="email"
                label="이메일"
                validateFirst={true}
                rules={[
                  {
                    required: true,
                    message: '이메일을 입력 하세요.',
                  },
                  {
                    type: 'email',
                    message: '이메일 입력이 잘못 되었습니다.',
                  },
                  {
                    validator: (_, value) => _checkEmailIsDuplicated(value),
                  },
                ]}
              >
                <Input type="email" placeholder="이메일" />
              </Form.Item>
            </Col>
          )}
        </Row>
        {!data && (
          <Row justify="center">
            <Col span={11}>
              <Form.Item
                name="password"
                label="비밀번호"
                validateFirst={true}
                rules={[
                  {
                    required: true,
                    message: '비밀번호를 입력 하세요.',
                  },
                  {
                    validator: (_, value) => validatePassword(value),
                  },
                ]}
              >
                <Input.Password placeholder="새 비밀번호" />
              </Form.Item>
            </Col>
          </Row>
        )}
        {!data && (
          <Row justify="center">
            <Col span={11}>
              <Form.Item
                name="password2"
                label="비밀번호 확인"
                validateFirst={true}
                rules={[
                  {
                    required: true,
                    message: '비밀번호를 입력 하세요.',
                  },
                  {
                    validator: (_, value) => validatePassword2(value),
                  },
                ]}
              >
                <Input type="password" placeholder="새 비밀번호 확인" />
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row justify="center">
          <Col span={11}>
            <Form.Item name="team" label="소속">
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={11}>
            <Form.Item name="workPosition" label="직책">
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={11}>
            <Form.Item
              name="workPhone"
              label="연락처(회사)"
              rules={[
                {
                  validator: (_, value) => checkGeneralPhoneNumber(value),
                },
              ]}
            >
              <Input type="text" placeholder="회사 전화 번호를 입력하세요." />
            </Form.Item>
          </Col>
        </Row>

        {!data && (
          <Row>
            <Col span={11}>
              <Form.Item
                name="isTermsOfServiceEnabled"
                valuePropName="checked"
                rules={[
                  {
                    validator: (_, value) =>
                      value
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error(
                              '서비스 이용약관을 확인 및 동의 부탁드립니다.',
                            ),
                          ),
                  },
                ]}
              >
                <Checkbox style={{ width: '100%' }}>
                  (필수){' '}
                  <Link
                    href="https://constlink-sample-files-bucket.s3.ap-northeast-2.amazonaws.com/%E1%84%89%E1%85%A5%E1%84%87%E1%85%B5%E1%84%89%E1%85%B3+%E1%84%8B%E1%85%B5%E1%84%8B%E1%85%AD%E1%86%BC%E1%84%8B%E1%85%A3%E1%86%A8%E1%84%80%E1%85%AA%E1%86%AB.pdf"
                    target="_blank"
                  >
                    서비스 이용약관
                  </Link>{' '}
                  을 확인하였고, 이에 동의합니다.
                </Checkbox>
              </Form.Item>
            </Col>
          </Row>
        )}
        {!data && (
          <Row>
            <Col span={11}>
              <Form.Item
                name="isPrivacyPolicyEnabled"
                valuePropName="checked"
                rules={[
                  {
                    validator: (_, value) =>
                      value
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error(
                              '개인정보처리방침을 확인 및 동의 부탁드립니다.',
                            ),
                          ),
                  },
                ]}
              >
                <Checkbox style={{ width: '100%' }}>
                  (필수){' '}
                  <Link
                    href="https://constlink-sample-files-bucket.s3.ap-northeast-2.amazonaws.com/%E1%84%80%E1%85%A2%E1%84%8B%E1%85%B5%E1%86%AB%E1%84%8C%E1%85%A5%E1%86%BC%E1%84%87%E1%85%A9+%E1%84%8E%E1%85%A5%E1%84%85%E1%85%B5%E1%84%87%E1%85%A1%E1%86%BC%E1%84%8E%E1%85%B5%E1%86%B7.pdf"
                    target="_blank"
                  >
                    개인정보처리방침
                  </Link>{' '}
                  을 확인하였고, 이에 동의합니다.
                </Checkbox>
              </Form.Item>
            </Col>
          </Row>
        )}

        <Row justify="center">
          <Form.Item>
            <Space size="middle">
              <Button htmlType="button" onClick={onCancel}>
                취소
              </Button>
              <Button htmlType="submit" type="primary">
                확인
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </Form>
    </>
  );
}

export default ProfileCreateUpdateComponent;
